import { Button, Container, List, ListItem, ListItemText, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router';

export default function PrivacyPolicyTerms() {
  return (
    <Container sx={{ p: 1 }}>
      <Typography variant="h4" gutterBottom>
        Privacy Policy
      </Typography>
      <Typography variant="body1" paragraph>
        Jarrell Entertainment ("we," "us," or "our") operates the Jarrell Entertainment App. This page informs you of
        our policies regarding the collection, use, and disclosure of personal data when you use our App and the choices
        you have associated with that data.
      </Typography>
      <Typography variant="body1" paragraph>
        By using the App, you agree to the collection and use of information in accordance with this policy.
      </Typography>

      <Typography variant="h5" gutterBottom>
        Information Collection and Use
      </Typography>
      <Typography variant="body1" paragraph>
        We collect several types of information for various purposes to provide and improve our service to you.
      </Typography>

      <Typography variant="h6" gutterBottom>
        Types of Data Collected
      </Typography>

      <Typography variant="subtitle1" gutterBottom>
        Personal Data
      </Typography>
      <Typography variant="body1" paragraph>
        While using our App, we may ask you to provide us with certain personally identifiable information that can be
        used to contact or identify you ("Personal Data"). Personal Data may include, but is not limited to:
      </Typography>
      <ListItem>
        <ListItemText primary="Name" />
      </ListItem>
      <ListItem>
        <ListItemText primary="Phone number" />
      </ListItem>
      <ListItem>
        <ListItemText primary="Email address" />
      </ListItem>
      <Typography variant="subtitle1" gutterBottom>
        Usage Data
      </Typography>
      <Typography variant="body1" paragraph>
        We may also collect information on how the App is accessed and used ("Usage Data"). This Usage Data may include
        information such as your device's Internet Protocol address (e.g., IP address), device type, operating system
        version, the pages of our App that you visit, the time and date of your visit, the time spent on those pages,
        and other diagnostic data.
      </Typography>

      <Typography variant="h5" gutterBottom>
        Use of Data
      </Typography>
      <Typography variant="body1" paragraph>
        We use the collected data for various purposes, including but not limited to:
      </Typography>
      <List>
        <ListItem>
          <ListItemText primary="Sending you updates and notifications about events or relevant information via text message" />
        </ListItem>
        <ListItem>
          <ListItemText primary="Providing customer support and assistance" />
        </ListItem>
        <ListItem>
          <ListItemText primary="Improving the user experience of our App" />
        </ListItem>
        <ListItem>
          <ListItemText primary="Analyzing usage patterns and trends to enhance our service" />
        </ListItem>
      </List>

      <Typography variant="h5" gutterBottom>
        Disclosure of Data
      </Typography>
      <Typography variant="body1" paragraph>
        We do not sell, trade, or otherwise transfer your Personal Data to third parties for promotional/marketing
        purposes.
      </Typography>

      <Typography variant="h5" gutterBottom>
        Retention of Data
      </Typography>
      <Typography variant="body1" paragraph>
        We will retain your Personal Data only for as long as is necessary for the purposes set out in this Privacy
        Policy. We will retain and use your Personal Data to the extent necessary to comply with our legal obligations
        (for example, if we are required to retain your data to comply with applicable laws), resolve disputes, and
        enforce our legal agreements and policies.
      </Typography>

      <Typography variant="h4" gutterBottom>
        Terms and Conditions
      </Typography>
      <Typography variant="body1" paragraph>
        These Terms and Conditions ("Terms", "Terms of Service") govern your use of the Jarrell Entertainment App
        ("App") operated by Jarrell Entertainment ("us", "we", or "our").
      </Typography>
      <Typography variant="body1" paragraph>
        By accessing or using the App, you agree to be bound by these Terms. If you disagree with any part of the terms,
        then you may not access the App.
      </Typography>

      <Typography variant="h5" gutterBottom>
        1. Use of Service
      </Typography>
      <List>
        <ListItem>
          <ListItemText primary="The Jarrell Entertainment App provides correspondence services to contractors for event coordination. The service is provided free of charge." />
        </ListItem>
        <ListItem>
          <ListItemText primary="By using the App, you agree to receive text correspondence regarding event updates." />
        </ListItem>
        <ListItem>
          <ListItemText primary="You may opt out of receiving correspondence at any time by texting 'STOP' to the provided number." />
        </ListItem>
      </List>

      <Typography variant="h5" gutterBottom>
        2. Intellectual Property
      </Typography>
      <Typography variant="body1" paragraph>
        The App and its original content, features, and functionality are owned by Jarrell Entertainment and are
        protected by international copyright, trademark, patent, trade secret, and other intellectual property or
        proprietary rights laws.
      </Typography>

      <Typography variant="h5" gutterBottom>
        3. Disclaimer
      </Typography>
      <Typography variant="body1" paragraph>
        The App and its services are provided on an "as is" and "as available" basis. Jarrell Entertainment makes no
        warranties, expressed or implied, and hereby disclaims and negates all other warranties including, without
        limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or
        non-infringement of intellectual property or other violation of rights.
      </Typography>

      <Typography variant="h5" gutterBottom>
        4. Limitations
      </Typography>
      <Typography variant="body1" paragraph>
        In no event shall Jarrell Entertainment be liable for any damages (including, without limitation, damages for
        loss of data or profit, or due to business interruption) arising out of the use or inability to use the App,
        even if Jarrell Entertainment or an authorized representative has been notified orally or in writing of the
        possibility of such damage.
      </Typography>

      <Typography variant="h5" gutterBottom>
        5. Governing Law
      </Typography>
      <Typography variant="body1" paragraph>
        These Terms shall be governed and construed in accordance with the laws of the United States of America, without
        regard to its conflict of law provisions.
      </Typography>

      <Typography variant="h5" gutterBottom>
        6. Changes
      </Typography>
      <Typography variant="body1" paragraph>
        We reserve the right, at our sole discretion, to modify or replace these Terms at any time. If a revision is
        material, we will provide at least 30 days' notice prior to any new terms taking effect. What constitutes a
        material change will be determined at our sole discretion.
      </Typography>
      <Typography variant="body1" paragraph>
        By continuing to access or use our App after those revisions become effective, you agree to be bound by the
        revised terms. If you do not agree to the new terms, please stop using the App.
      </Typography>

      <Typography variant="h5" gutterBottom>
        7. Contact Us
      </Typography>
      <Typography variant="body1" paragraph>
        If you have any questions about these Terms, please contact us at office@jarrellentertainment.com.
      </Typography>
    </Container>
  );
}
